import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import Avatar from "@material-ui/core/Avatar";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Paper from "@material-ui/core/Paper";
import Modal from "@material-ui/core/Modal";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import store from "../../../reduxstore";
import SERVER_ADDRESS from "../../../config";
import { authWrapper } from "../../../auth";

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 2
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  button: {
    margin: theme.spacing(1)
  },
  appbar: {
    marginBottom: 1
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
  },
  avatar: {
    margin: theme.spacing(),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing()
  },
  submit: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  modal: {
    width: "350px",
    margin: "200px auto"
  }
}));

function PasswordChangeForm(props) {
  const classes = useStyles();
  const [password, setPassword] = useState("");
  const [passwordValidator, setPasswordValidator] = useState("");
  //refs
  const passwordRef = React.createRef();
  const passwordValidatorRef = React.createRef();

  const handleBlur = refCurrent => {
    return event => {
      refCurrent.current.validate(event.target.value);
    };
  };
  //提交修改密码
  const handleSubmit = postUrl => {
    return e => {
      e.preventDefault();
      if (password !== passwordValidator) {
        props.enqueueSnackbar("两次密码填写不同，请重新填写", {
          variant: "error"
        });
        return null;
      } else {
        let h = new Headers();
        h.append("Accept", "application/*");
        let formdata = new FormData();
        formdata.append("password", password);

        let req = new Request(postUrl, {
          method: "POST",
          headers: {
            Accept: "application/json, text/plain, */*"
          },
          mode: "cors",
          credentials: "include",
          body: formdata
        });

        fetch(req)
          .then(res => {
            if (!res.ok) {
              throw Error(res.statusText);
            } else {
              setPassword("");
              setPasswordValidator("");
              props.enqueueSnackbar("成功更新密码,请重新登录", {
                variant: "success"
              });
              window.location.reload();
            }
          })
          .catch(error => {
            props.enqueueSnackbar("修改密码失败", {
              variant: "error"
            });
          });
      }
    };
  };
  return (
    <ValidatorForm
      className={classes.form}
      onSubmit={handleSubmit(`${SERVER_ADDRESS}/api/changepasswd/`)}
      instantValidate={true}
      noValidate
    >
      <TextValidator
        ref={passwordRef}
        type="password"
        autoFocus
        required
        fullWidth
        label="新密码"
        onBlur={handleBlur(passwordRef)}
        onChange={e => {
          setPassword(e.target.value);
        }}
        name="password"
        value={password}
        validators={["required"]}
        errorMessages={["新密码不能为空"]}
        helperText="请输入新密码，不填则不修改密码"
      />
      <TextValidator
        ref={passwordValidatorRef}
        type="password"
        required
        fullWidth
        label="重复密码"
        onBlur={handleBlur(passwordValidatorRef)}
        onChange={e => {
          setPasswordValidator(e.target.value);
        }}
        name="password"
        value={passwordValidator}
        validators={["required"]}
        errorMessages={["请重复输入密码"]}
        helperText="请再次输入新密码"
      />

      <br />
      <Button
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
        type="submit"
      >
        修改密码
      </Button>
    </ValidatorForm>
  );
}

const withSnackbarPasswordChangeForm = withSnackbar(PasswordChangeForm);

//权限设置，某些用户可能不允许修改密码
const AuthPasswordChangeForm = authWrapper(["教师", "学生"])(
  withSnackbarPasswordChangeForm
);
export default AuthPasswordChangeForm;
